import { FC } from "react";
import { MinMaxEditor, hasMinMaxErrors, getHumanMinMax } from "./MinMaxEditor";
import type { ScoringType, MinMaxBand } from "@/lib/scoring/types";

export const initialBand: MinMaxBand = { score: 0 };
export const hasErrors = (bands: unknown[]) =>
  hasMinMaxErrors(bands as MinMaxBand[]);
export const getBandSummary = (band: unknown) => {
  const b = band as MinMaxBand;
  return getHumanMinMax(b.min, b.max, "$");
};

interface Props {
  criterion: ScoringType;
  onChange: (updated: ScoringType) => void;
}

export const RevenueEditor: FC<Props> = ({ criterion, onChange }) => (
  <MinMaxEditor
    bands={criterion.revenue ?? []}
    onChange={(bands) => onChange({ ...criterion, revenue: bands })}
    minLabel="Min Revenue"
    maxLabel="Max Revenue"
    thousandSeparator
    prefix="$"
  />
);
